import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CommitIcon } from "@radix-ui/react-icons";
import DisplayUpdateTime from "ui/DisplayUpdateTime";
import { AvatarMediaPreview } from "AdminPanel/SpineAvatars/SpineAvatars/components/AvatarMediaPreview";
import { columnDraftState } from "components/template-data-table-column";

export const columns = [
  {
    header: "#",
    cell: ({ row }: { row: { index: number } }) => row.index + 1,
  },
  {
    header: "Preview",
    accessorKey: "preview",
    cell: ({
      row,
    }: {
      row: {
        original: {
          preview?: string;
          videoPreview?: string;
          videoPreviewPreview?: string;
          videoCover?: string;
          videoCoverPreview?: string;
        };
      };
    }) => {
      const preview = row.original.preview;
      const videoUrl =
        row.original.videoPreviewPreview ||
        row.original.videoPreview ||
        (row.original as any).previewCover ||
        row.original.videoCoverPreview ||
        row.original.videoCover;
      return preview || videoUrl ? (
        <div className="aspect-square rounded-md h-24 w-24 overflow-hidden border bg-black">
          <AvatarMediaPreview
            videoUrl={videoUrl}
            imageUrl={preview}
            className="h-full w-full"
          />
        </div>
      ) : (
        <div className="aspect-square rounded-md bg-muted h-24 w-24 flex items-center justify-center text-xs text-muted-foreground">
          -
        </div>
      );
    },
  },
  {
    header: "Name",
    accessorKey: "name",
    cell: ({ row }: { row: { original: { name?: string; id: string } } }) => (
      <div className="max-w-[200px] truncate" title={row.original.name}>
        {row.original.name || row.original.id}
      </div>
    ),
  },
  {
    header: "Type",
    accessorKey: "type",
  },
  columnDraftState,
  {
    header: "Products",
    accessorKey: "productIds",
    cell: ({
      row,
    }: {
      row: { original: { productIds?: number[] } };
    }) => {
      const ids = row.original.productIds;
      if (!Array.isArray(ids) || ids.length === 0) {
        return <span className="text-xs text-muted-foreground">—</span>;
      }
      return (
        <span className="text-xs text-muted-foreground">{ids.join(", ")}</span>
      );
    },
  },
  {
    header: "UpdateTime",
    accessorKey: "updateTime",
    cell: ({
      row,
    }: {
      row: { original: { updateTime?: number } };
    }) => <DisplayUpdateTime updateTime={row.original.updateTime} />,
  },
  {
    header: "Actions",
    cell: ({ row }: { row: { original: { id: string } } }) => (
      <Button asChild size="sm">
        <Link to={`/admin/spine/review/${row.original.id}`}>
          <CommitIcon className="w-4 h-4 mr-2" />
          Review
        </Link>
      </Button>
    ),
  },
];
